// Correct a legacy visible option label without changing product option data.
(() => {
  // Some imported products have a first variant in another color than the
  // product title and featured photo. Keep explicit variant links untouched.
  const selectTitleColor = () => {
    if (!document.body.classList.contains('template-product') || new URLSearchParams(location.search).has('variant')) return;
    const title = document.querySelector('.product-info h1')?.textContent.trim();
    if (!title?.includes(' - ')) return;
    const color = title.split(' - ').pop().trim();
    const picker = document.querySelector('.product-info variant-picker');
    const colorFieldset = [...(picker?.querySelectorAll('fieldset.variant-picker__option') || [])]
      .find((fieldset) => /^(color|collor|colour):?$/i.test(fieldset.querySelector('legend')?.textContent.trim() || ''));
    const input = [...(colorFieldset?.querySelectorAll('input[type="radio"]') || [])]
      .find((radio) => radio.value.toLowerCase() === color.toLowerCase());
    if (!input || input.checked || input.disabled) return;
    // The theme loads variant data asynchronously before attaching its change
    // listener. Wait for that initialization so cart and bundle IDs stay in sync.
    let frames = 0;
    const applyWhenReady = () => {
      if (new URLSearchParams(location.search).has('variant')) return;
      if (picker.product && picker.selectedVariant) input.click();
      else if (++frames < 180) requestAnimationFrame(applyWhenReady);
    };
    applyWhenReady();
  };
  customElements.whenDefined('variant-picker').then(() => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectTitleColor, { once: true });
    else selectTitleColor();
  });

  const updateLabels = () => {
    document.querySelectorAll('.swatch-option-name').forEach((label) => {
      if (label.textContent.trim().toLowerCase() === 'collor') label.textContent = 'Color';
    });
    document.querySelectorAll('.kaching-bundles__bar-variant-names span').forEach((label) => {
      if (label.textContent.trim().toLowerCase() === 'collor') label.textContent = 'Color';
    });
    document.querySelectorAll('.kaching-bundles__bar-variant-select[aria-label]').forEach((select) => {
      if (select.getAttribute('aria-label').trim().toLowerCase() === 'collor') select.setAttribute('aria-label', 'Color');
    });
    // Swatch King requests a square top-crop of the product image. For shoes this
    // cuts away the sole. Request the same original image uncropped instead.
    document.querySelectorAll('.template-product variant-swatch-king .swatch-view-image .star-set-image').forEach((image) => {
      const cssImage = image.style.backgroundImage;
      const match = cssImage.match(/^url\(["']?(.*?)["']?\)$/);
      if (!match) return;
      const url = new URL(match[1], window.location.href);
      if (!url.searchParams.has('crop') && !url.searchParams.has('height')) return;
      url.searchParams.delete('width');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      url.searchParams.set('width', '300');
      image.style.backgroundImage = `url("${url.toString()}")`;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLabels, { once: true });
  } else {
    updateLabels();
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateLabels();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 2026-09-22: a opção dos produtos se chama "Collor" no admin (erro de digitação). O carrinho do UpCart
   mostra "Collor: ...": troca o rótulo na tela. O certo é renomear a opção em Produtos > Opções. */
(() => {
  const fix = (root) => {
    root.querySelectorAll('.upcart-internal-cart-items__key-value-pair').forEach((el) => {
      if (!el.textContent.includes('Collor')) return;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) if (node.nodeValue.includes('Collor')) node.nodeValue = node.nodeValue.replace(/\bCollor\b/g, 'Color');
    });
  };
  const attach = () => {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) return false;
    if (root.towCollor) return true;
    root.towCollor = true;
    fix(root);
    new MutationObserver(() => fix(root)).observe(root, { childList: true, subtree: true, characterData: true });
    return true;
  };
  if (!attach()) {
    const watcher = new MutationObserver(() => { if (attach()) watcher.disconnect(); });
    watcher.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* 2026-09-22: a bolha do Chat ficava em cima do botão da barra fixa "Add to cart". Sobe a bolha enquanto a barra aparece. */
(() => {
  const bar = document.querySelector('product-quick-add');
  if (!bar) return;
  const apply = () => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    if (!root || !root.querySelector('.activator-nudge')) return false;
    let style = root.getElementById('tow-chat-lift');
    if (!style) { style = document.createElement('style'); style.id = 'tow-chat-lift'; root.appendChild(style); }
    const lift = bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) + 12;
    style.textContent = '.activator-nudge{transition:bottom .2s ease}'
      + (bar.classList.contains('is-visible') ? '.activator-nudge{bottom:' + lift + 'px !important}' : '');
    return true;
  };
  new MutationObserver(apply).observe(bar, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', apply);
  if (!apply()) {
    const watcher = new MutationObserver(() => { if (apply()) watcher.disconnect(); });
    watcher.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => watcher.disconnect(), 30000);
  }
})();
